"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function hexToRGB(hex) {
  var r = 0,
      g = 0,
      b = 0;

  if (hex.length == 7) {
    r = "0x" + hex[1] + hex[2];
    g = "0x" + hex[3] + hex[4];
    b = "0x" + hex[5] + hex[6];
  }

  return "rgb(" + +r + "," + +g + "," + +b + ")";
}

exports.default = hexToRGB;